import EmailMessageList from "./pages/ListPage.vue";
import EmailMessageIndex from "./pages/IndexPage.vue";

export default [
  {
    path: "/email_message",
    component: EmailMessageIndex,
    redirect: "/email_message/list",
    name: "email_message",
    children: [
      {
        path: "list",
        component: EmailMessageList,
        name: "email_message.list",
        // The ff. code is taken from https://git.o.ocom.com.au/django/mcharrys_portal/issues/230#issuecomment-39327
        beforeEnter(to, from, next) {
          window.open(
            "/ui/email_message/list?order=desc&sort=created",
            "_blank"
          );
          return false; // don't
        },
      },
    ],
  },
];
